<template>
  <div class="home" :class="{'scroll-off': $store.state.scrollOff}">

    <Info/>
    <Bouts 
      :posts="$store.state.allaPosterData"
    />
    <Highscore 
      :posts="$store.state.allaPosterData"
    />
    <Posts 
      :userinfo="userinfo"
      :useractions="useractions"
      :posts="$store.state.allaPosterData"
    />
    
    <div class="btn-load-more" v-show="$store.state.showLoadMore" @click="fetchPosts">
      <h1 class="dark-grey">↓↓↓</h1>
      <h1>Load More</h1>
      <h1 class="dark-grey">&nbsp;/ 13 Posts</h1>
    </div>

    <Bouts 
      :posts="$store.state.allaPosterData"
    />
    <Footer/>

  </div>
</template>
<script>
import { auth, db, fs } from '../db'
import Info from '@/components/Info.vue'
import Posts from '@/components/Posts.vue'
import Navbar from '@/components/Navbar.vue'
import Bouts from '@/components/Bouts.vue'
import Highscore from '@/components/Highscore.vue'
import Footer from '@/components/Footer.vue'
import BottomNav from '@/components/BottomNav.vue'

export default {
  name: 'home',
  props: [
    "userinfo",
    "useractions"
  ],
  components: {
    Navbar,
    Posts,
    Bouts,
    Highscore,
    Info,
    Footer,
    BottomNav
  },
  created() {
    this.fetchPosts()
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$store.commit('activePage', 'feed')
//INFINITE LADDA POSTER SCROLL FUNKTION
    // this.scrolledToBottom()
  },
  methods: {
    fetchPosts() {
      this.$store.dispatch('fetchPosts')
    },
//INFINITE LADDA POSTER SCROLL FUNKTION
    // scrolledToBottom () {
      // window.onscroll = () => {
      //   let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
      //   if (bottomOfWindow) {
      //     this.$store.dispatch('fetchPosts')
      //   }
      // }
    // },
  }
 
}

</script>
<style lang="scss">
@import "../scss/_variables.scss";
.home {
  padding-top: $nav-height;
}
</style>
